import Footer from '@/components/structure/Footer';
import TopNavigation from '@/components/structure/navigation/TopNavigation';

export default [
    {
        path: '/faq',
        name: 'faq',
        redirect: { name: 'faq.categories' },
        components: {
            // route level code-splitting. This generates a separate chunk (faq.[hash].js) for this route which is
            // lazy-loaded when the route is visited.
            default: () => import(/* webpackChunkName: "faq" */ '@/views/Faq'),
            footer: Footer,
            topNavigation: TopNavigation,
            orderSummaryModal: () => import(/* webpackChunkName: "order-modal" */ '@/components/modals/shop/OrderSummaryModal'),
        },
        children: [
            {
                path: 'categories',
                name: 'faq.categories',
                component: () => import(/* webpackChunkName: "faq" */ '@/views/faq/FaqCategories'),
            },
            {
                path: '*',
                name: 'faq.answers',
                component: () => import(/* webpackChunkName: "faq" */ '@/views/faq/FaqAnswers'),
            },
        ],
    },
];
